<template>
  <div id="NavigationComponent">
    <v-navigation-drawer
      ref="nav"
      v-model="drawer"
      app
      class="navigation"
      floating
      :permanent="!isMobile"
      dark
    >
      <div class="d-flex justify-center align-center">
        <v-img
          src="/agency-file/logo"
          alt="agency logo"
          class="logo-size"
          transition="scale-transition"
          contain
          height="100px"
        />
      </div>
      <v-divider class="mt-0" />
      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="{ name: item.route }"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-for="(complexItem, complexKey) in complexItems"
          :key="complexKey"
          no-action
          :prepend-icon="complexItem.icon"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>
                {{ complexItem.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(child, i) in complexItem.children"
            :key="i"
            link
            :to="{ name: child.route }"
          >
            <v-list-item-title v-text="child.title" />
          </v-list-item>
        </v-list-group>
        <div class="show-on-mobile">
          <v-divider />
          <v-list-item :to="{ name: 'settings' }">
            <v-list-item-action>
              <v-icon>mdi-account-cog</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Settings
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="floUrl !== null"
            :href="'https://' + floUrl"
            target="_blank"
          >
            <v-list-item-action>
              <v-icon>mdi-arrow-up-bold-box-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Go to Flo
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="showGuide"
            to="/guides"
            target="_blank"
          >
            <v-list-item-action>
              <v-icon>mdi-file-document</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                User Guide
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            @click="logout()"
          >
            <v-list-item-action>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Logout
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <div class="contact-container">
            <div class="contact-header">
              Contact Flo
            </div>
            <div class="contact-tel">
              Support Line:
              <a href="tel: 01827 438065">01827 438065</a>
            </div>
            <div class="contact-email">
              Raise a ticket:
              <a
                class="contactLnk"
                href="https://flosupportticket.bitrix24.site"
                target="_blank"
              >Here</a>
            </div>
          </div>
        </div>
      </v-list>

      <template v-slot:append>
        <div class="show-on-desktop">
          <div class="contact-container">
            <div class="contact-header">
              Contact Flo
            </div>
            <div class="contact-tel">
              Support Line:
              <a href="tel: 01827 438065">01827 438065</a>
            </div>
            <div class="contact-email">
              Raise a ticket:
              <a
                class="contactLnk"
                href="https://flosupportticket.bitrix24.site"
                target="_blank"
              >Here</a>
            </div>
          </div>
          <v-list dense>
            <v-list-item :to="{ name: 'settings' }">
              <v-list-item-action>
                <v-icon>mdi-account-cog</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Settings
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="floUrl !== null"
              :href="'https://' + floUrl"
              target="_blank"
            >
              <v-list-item-action>
                <v-icon>mdi-arrow-up-bold-box-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Go to Flo
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="showGuide"
              to="/guides"
              target="_blank"
            >
              <v-list-item-action>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  User Guide
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              @click="logout()"
            >
              <v-list-item-action>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Logout
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      dense
      class="d-flex d-md-none navigation"
      color="$agencyColorPrimary"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Candidate Portal</v-toolbar-title>
    </v-app-bar>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'NavigationComponent',

  props: {
    items: {
      type: Array,
      default: () => {
        return {}
      }
    },
    complexItems: {
      type: Array,
      default: () => {
        return {}
      }
    },
    color: {
      type: String,
      default: '#4dc7e9'
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    floUrl: null,
    drawer: false,
    settings: {},
    showGuide: false
  }),
  computed: {
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return true
        default:
          return false
      }
    },

    isLarge () {
      return this.$vuetify.breakpoint.name === 'xl'
    },

    isMini () {
      if (this.$refs.nav !== undefined) {
        return this.$refs.nav.isMiniVariant
      }
      return false
    },
    logoSrc () {
      return this.settings.logo ? '/agency-file/logo' : ''
    }
  },
  mounted () {
    if (localStorage.darkMode) {
      const value = localStorage.darkMode === 'true'
      this.$vuetify.theme.dark = value
    }
    this.LoadStateDependencies(['agencies.agency']).then(
      isAgency => {
        this.settings =
                    this.$store.state.agencies.agency.settings ?? {}
        if (!this.$store.state.users.user.is_admin) {
          this.showGuide = true
        }
      },
      isCandidate => {
        this.LoadStateDependencies(['candidates.candidate']).then(
          response => {
            this.settings =
                            this.$store.state.candidates.candidate
                              .agency_settings ?? {}
            this.showGuide = true
          }
        )
      }
    )
    this.getFloUrl()
  },
  methods: {
    logout () {
      const formData = new FormData()
      formData.append('_method', 'POST')
      axios.post(this.URLs.core.auth.logout, formData).then(response => {
        window.location.href = this.URLs.core.auth.login
      })
    },
    getFloUrl () {
      axios.get('/api/agency-flo-url').then(response => {
        this.floUrl = response.data + '.flosolutions.co.uk'
      })
    },
    setDarkMode () {
      localStorage.darkMode = this.$vuetify.theme.dark
    }
  }
}
</script>
<style lang="scss">
@import "./resources/sass/variables";
@import "./resources/sass/agencyTheming";

@media (max-width: 845px) {
    .show-on-mobile {
        display: block;
    }

    .show-on-desktop {
        display: none;
    }
}

@media (min-width: 846px) {
    .show-on-mobile {
        display: none;
    }

    .show-on-desktop {
        display: block;
    }
}

#NavigationComponent {
    .v-list--dense .v-list-item .v-list-item__subtitle,
    .v-list--dense .v-list-item .v-list-item__title,
    .v-list-item--dense .v-list-item__subtitle,
    .v-list-item--dense .v-list-item__title {
        font-size: 0.92rem;
        line-height: 1.3rem;
    }
    .navigation {
        color: $agencyColorPrimary;
        background-color: $agencyColorPrimary;
        z-index: 15;
    }
    .logo-size {
        max-width: 200px;
        max-height: 100px;
        margin: 1rem;
    }
    .contact-container {
        font-size: 14px;
        color: #fff;
        padding: 20px 2px 15px 15px;
    }
    .contact-header {
        padding-bottom: 12px;
    }
    .contact-tel a {
        color: #fff;
    }
    .contact-email {
        padding-top: 5px;
    }
    .contactLnk {
        color: #fff;
        text-decoration: underline !important;
    }
}
</style>
